import { inject, Injectable, signal } from '@angular/core';
import { FirebaseApp } from '@angular/fire/app';
import { Auth } from '@angular/fire/auth';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, UserCredential } from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private auth: Auth;

  isAuthenticated = signal<boolean>(false);

  constructor() {
    const app = inject(FirebaseApp);
    this.auth = getAuth(app);

    onAuthStateChanged(this.auth, (user) => {
      this.isAuthenticated.set(!!user);
    });
  }


  login(email: string, password: string): Promise<UserCredential> {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  logOut(): Promise<void> {
    return signOut(this.auth);
  }


  isLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      onAuthStateChanged(this.auth, (user) => {
        resolve(!!user);
      });
    });
  }
}
